<template>
	<div class="body">
		<critical-notification class="no-sidebar"></critical-notification>
		<div class="main-wrap">
			<main-header></main-header>
			<main-wrapper></main-wrapper>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import CriticalNotification from "@/components/CriticalNotification.vue";
import MainHeader from "@/components/NewHeader.vue";
import MainWrapper from "@/components/enterPhone/PageWrap.vue";
export default {
  components: {
    CriticalNotification,
    MainHeader,
    MainWrapper
  },
  metaInfo() {
    return { title: this.$t("titles.enter_phone") }
  }
};
</script>

<style lang="scss" scoped></style>